"use client";

import { useState } from "react";
import { ArrowUp } from "lucide-react";
import HeaderBanner from "../components/HeaderBanner";
import UserPreferencesModal from "./components/UserPreferencesModal";

export default function UserTypePage() {
  const [isModalOpen, setIsModalOpen] = useState(true);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <main className="min-h-screen bg-white">
      <section
        className="flex flex-col items-center justify-center min-h-screen px-4 text-center bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('/images/landing-new/Estrellas_Header.png')`,
          backgroundSize: "35%",
        }}
      >
        <HeaderBanner />
        <div className="w-full max-w-4xl mx-auto">
          {/* Subtitle - A better way */}
          <h2 className="mb-16 text-4xl font-normal leading-tight sm:text-5xl md:text-6xl lg:text-7xl">
            <span className="text-gray-900">A </span>
            <span className="bg-[linear-gradient(90deg,#B71BFF_24.04%,#5B02FF_48.56%,#8F36FF_100%)] bg-clip-text text-transparent">
              better
            </span>
            <span className="text-gray-900"> way to</span>
            <br />
            <span className="text-gray-900">match with people.</span>
          </h2>

          {/* Message Input Section */}
          <div className="relative max-w-2xl mx-auto">
            {/* Hovering message bubble - positioned on left side */}
            <div className="absolute z-10 transition-opacity duration-300 opacity-100 pointer-events-none -top-16 left-4">
              {/* Message bubble with white background - thinner padding */}
              <div className="relative bg-white px-4 py-2.5 rounded-2xl shadow-lg border border-gray-200 flex items-center gap-2.5">
                {/* Circle with gradient and magic icon */}
                <div className="flex items-center justify-center w-8 h-8 rounded-full md:w-10 md:h-10 bg-linear-to-t from-brand-200 to-white shrink-0">
                  <svg
                    className="w-4 h-4 md:w-5 md:h-5 text-brand-500"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z"
                    />
                  </svg>
                </div>

                <p className="text-xs font-medium text-gray-700 md:text-sm whitespace-nowrap">
                  Who are you looking for?
                </p>

                {/* Triangle pointer */}
                <div className="absolute w-4 h-4 rotate-45 bg-white border-b border-r border-gray-200 -bottom-2 left-8"></div>
              </div>
            </div>

            {/* Input container with gradient border */}
            <div className="relative">
              <div className="rounded-[24px] p-0.5 bg-[linear-gradient(76deg,rgba(183,27,255,1)_0%,rgba(91,2,255,1)_53%,rgba(143,54,255,1)_100%)] shadow-xl">
                {/* Content */}
                <div className="bg-white rounded-[23px] px-6 py-5 flex items-center gap-3">
                  <input
                    type="text"
                    placeholder="Eg. Software engineer in SF working in Series B companies, skilled in Python, Next.js..."
                    className="flex-1 text-sm md:text-base bg-[#F5F5F5] p-2 rounded-full border-none outline-none text-gray-800 placeholder:text-gray-400"
                  />

                  {/* Botón circular con flecha hacia arriba */}
                  <button
                    type="button"
                    onClick={handleOpenModal}
                    className="flex items-center justify-center w-10 h-10 rounded-full bg-gradient-to-r from-[#5B02FF] to-[#8F36FF] hover:bg-brand-600 transition-colors flex-shrink-0"
                  >
                    <ArrowUp className="w-5 h-5 text-white" />
                  </button>
                </div>
              </div>
            </div>

            <div className="flex justify-end gap-3 mt-4">
              <button
                type="button"
                className="inline-flex items-center gap-2 px-5 py-2 text-sm font-semibold transition-colors border rounded-full border-brand-500 text-brand-500 hover:bg-brand-50"
              >
                Filters
                <svg
                  className="w-4 h-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M3 4h18l-7 8v6l-4-2v-4z"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>

        {/* Logos Image */}
        <div className="w-full px-4 mx-auto max-w-7xl mt-35">
          <img
            src="/images/landing-new/Logos.png"
            alt="Trusted by companies"
            className="w-full h-auto"
          />
        </div>
      </section>

      {/* User Preferences Modal */}
      <UserPreferencesModal isOpen={isModalOpen} onClose={handleCloseModal} />
    </main>
  );
}
